
  import Vue from 'vue'
  import MeteringService from '@/services/MeteringService';
import { extractErrorMessage } from '@/utils/Util';

  export default Vue.extend({
    name: 'TaskDeleteDialog',
    props: ['task'],
    data: () => ({
        localDialog: false,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading: false,
    }),
    methods: {
      close() {
        this.localDialog = false;
      },
      clear() {
        this.alertVisible = false;
        this.loading = false;
      },
      dismiss() {
        this.clear();
        this.close();
      },
      confirmDelete() {
        this.loading = true;
        
        MeteringService.deleteDeviceTask(this.$root.$store.state.session.selectedTenant.uuid, this.task.deviceId).then(() => {
            this.alertType = "success";
            this.alertText = this.$t('task.successDelete') as string;
            this.alertVisible = true;
            this.loading = false;

            setTimeout(() => { 
                this.$emit("delete", this.task);
                this.dismiss(); 
            }, 2000);
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('task.errorDelete') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        });
      }
    }
  })
